import { authflow, getTokenDetails } from '../utils/authflow';
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getIconFromName, useAuth } from '../provider/authprovider';

const Callback = (props) => {
    const [code, setCode] = useState(null);
    const [error, setError] = useState(null);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setAccessToken, setUserDetails } = useAuth();

    useEffect(() => {
        authflow.initAuthorizationHandler();
        setCode(searchParams.get('code'));
        if (!code) {
            return;
        }
        setAuthHandler()
    }, [code]);

    const setAuthHandler = async () => {
        try {
            const loginurlpath = localStorage.getItem("loginurlpath");
            let landingpageroute = (loginurlpath && loginurlpath ==='/ROS/internal/equinor')?'/ROS/internal/equinor':'/landingpage';
            authflow.setStateValues(updateStateValues);
            await authflow.setAuthorizationHandler(() => navigate(landingpageroute));
        } catch (err) {
            console.log('Error in setAuthHandler' + err);
            localStorage.removeItem("loginurlpath");
            setError(err);
        }
    };

    function updateStateValues(responseObj) {
        if (responseObj && responseObj.status === 'success') {
            const tokenDetails = getTokenDetails();
            const claimsObj = tokenDetails?.idToken?.claims;
            let userIdFromToken = (claimsObj?.user) ? claimsObj?.user: claimsObj?.preferred_username;
            setAccessToken(tokenDetails.accessToken.accessToken);
            setUserDetails({
                icon: getIconFromName(tokenDetails?.idToken?.claims?.name),
                userId: userIdFromToken,
                name: tokenDetails?.idToken?.claims?.name,
                email: tokenDetails?.idToken?.claims?.email,
                userGroup: tokenDetails?.idToken?.claims?.groups ?? [],
                isLoggedIn: true
            });
        } else {
            setError('Error while fetching access token');
        }
    };
    const loadingJsx = (!error) ? <div><h2 className="center-box">Loading...</h2></div> : <div ><h2 className="center-box">Error while fetching token..</h2></div>;
    return (<>{loadingJsx}</>);
};

export default Callback;
